// import { Swiper, SwiperSlide } from 'swiper/react';
// import "swiper/swiper-bundle.css";
// import { Pagination, Autoplay } from 'swiper/modules';
// import homeimg2 from "../../assest/images/homeimg2.png";
import { Pagination as RecordPagination } from '../../components/Pagination';
import helper, { convertToTime, formatMeetingLocation, getSlugByLang, getSlugNameByLang } from '../../common/Helper';
import TableRecordNotFound from '../../components/TableRecordNotFound';
import SKProductList from '../../components/Skeletons/SKProductList';
import noTour from "../../assest/myImages/no-tour-img.png";
import { Link } from 'react-router-dom';
// import React, { useState, useEffect } from 'react';
// import { Bar } from 'react-chartjs-2'; // Bar chart is typically used for histograms
// import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
// import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
// import ContentLoader from 'react-content-loader'
import BreadCrumb from '../../components/BreadCrumb';
import heartFill from '../../assest/images/heart-fill.png';
import heart from '../../assest/images/heart.png';
import { useSelector } from 'react-redux';
import SearchBoxComponent from './SearchBoxComponent';

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Index = ({
    productList,
    currentPage,
    totalPages,
    totalItems,
    onPageChange,
    isLoading,
    value,
    setValue,
    handleKeyDown,
    onClickSearchArrow,
    calendarRef,
    filterDurationTab,
    setFilterDurationTab,
    onClickTab,
    handleMinChange,
    handleMaxChange,
    minValue,
    maxValue,
    handleEnd,
    getPosition,
    resetFilter,
    xAxisLabels,
    sliderValue,
    onSliderChange,
    minPriceValue,
    maxPriceValue,
    categories,
    showAllCat,
    handleSeeMoreClick,
    handleSeeLessClick,
    selectedCategories,
    handleCheckboxChange,
    features,
    showAllFe,
    handleSeeFeMoreClick,
    handleSeeFeLessClick,
    isWheelChair,
    isPetsEnable,
    handleFeatureCheckboxChange,
    checkFeatureSelected,
    fromPrice,
    toPrice,
    tempFromPrice,
    tempToPrice,
    handleEndPrice,
    LogSlider,
    handleFilterClick,
    isOpen,
    breadcrumbArray,
    dropdownRef,
    showDropdown,
    setShowDropdown,
    isSearchLoading,
    productsSuggetion,
    activitiesSuggetion,
    destinationSuggetions,
    onClickProduct,
    onClickDestination,
    onClickActivity,
    handleKeyUp,
    sliderRef,
    selectedRange,
    suggetionHistory,
    onClickHistoryOption,
    toggleLike,
    blogsSuggetion,
    onClickBlog,
    categoryInput,
    onCategoryChange,
    featureSearch,
    onFeatureChange,
    setCategorySearch,
    categorySearch,
    onResetCategory,


    onResetFeature,
    featureInput,
    setFeatureSearch,

    setActiveSlider,
    activeSlider,
    setActiveTimeSlider,
    activeTimeSlider
}) => {


    const visibleCategories = showAllCat ? categories : categories.slice(0, 20);
    const remainingCatCount = categories.length - visibleCategories.length;

    const visibleFeatures = showAllFe ? features : features.slice(0, 5);
    const remainingFeCount = features.length - visibleFeatures.length;

    const user = useSelector((state) => state.user);
    const slugField = getSlugNameByLang(user?.language)

    const slugLang = getSlugByLang(user?.language)

    // console.log('suggetionHistory',suggetionHistory);
    // console.log('destinationSuggetions',destinationSuggetions);
    // console.log('activitiesSuggetion',activitiesSuggetion);
    // console.log('productsSuggetion',productsSuggetion);
    // console.log('value?.trim()?.length < 3',value?.trim()?.length < 3);





    return (
        <>


            <div className="detasilTitle">
                <div className="container">
                    <div className="detasilBox typeBox search-group">
                        <SearchBoxComponent
                            dropdownRef={dropdownRef}
                            value={value}
                            setValue={setValue}
                            showDropdown={showDropdown}
                            setShowDropdown={setShowDropdown}
                            handleKeyUp={handleKeyUp}
                            isSearchLoading={isSearchLoading}
                            productsSuggetion={productsSuggetion}
                            activitiesSuggetion={activitiesSuggetion}
                            destinationSuggetions={destinationSuggetions}
                            blogsSuggetion={blogsSuggetion}
                            suggetionHistory={suggetionHistory}
                            onClickHistoryOption={onClickHistoryOption}
                            onClickDestination={onClickDestination}
                            onClickActivity={onClickActivity}
                            onClickProduct={onClickProduct}
                            onClickBlog={onClickBlog}
                            slugField={slugField}
                        />

                    </div>
                    <BreadCrumb list={breadcrumbArray} />
                </div>
            </div>
            <section className="exploreTour">
                <div className="container">
                    <div className="explorePart">
                        <div className="sectionTitle">
                            <h3>Explore tours <span className='notranslate' translate="no">({totalItems}) </span></h3>
                        </div>
                        <div className="filterOpen">
                            <button className="btn btnFilter" onClick={handleFilterClick}><i className="bi bi-sliders"></i> Filter</button>
                        </div>
                        <div className="mainDetailsBox">
                            <div className="row">
                                <div className="col-lg-3">
                                    <div className={`mobiletoursTab ${isOpen ? 'open' : ''}`}>
                                        <div className="toursTab">
                                            <div className="title">
                                                <p>Availability</p>
                                            </div>
                                            <div className="innerTabBox">
                                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button className={`nav-link ${filterDurationTab == 'today' ? 'active' : ''}`} id="home-tab" data-bs-toggle="tab"
                                                            data-bs-target="#home" type="button" role="tab" aria-controls="home"
                                                            onClick={() => onClickTab('today')}
                                                            aria-selected="true">Today</button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className={`nav-link ${filterDurationTab == 'tomorrow' ? 'active' : ''}`} id="profile-tab" data-bs-toggle="tab"
                                                            data-bs-target="#profile" type="button" role="tab"
                                                            onClick={() => onClickTab('tomorrow')}
                                                            aria-controls="profile" aria-selected="false">Tomorrow</button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className={`nav-link ${filterDurationTab == 'dates' ? 'active' : ''}`} id="contact-tab" data-bs-toggle="tab"
                                                            data-bs-target="#contact" type="button" role="tab"
                                                            onClick={() => onClickTab('dates')}
                                                            aria-controls="contact" aria-selected="false">Dates</button>
                                                    </li>
                                                </ul>
                                                <div className="tab-content" id="myTabContent">
                                                    <div className={`tab-pane fade ${filterDurationTab == 'today' ? 'show active' : ''} `} id="home" role="tabpanel" aria-labelledby="home-tab"></div>
                                                    <div className={`tab-pane fade ${filterDurationTab == 'tomorrow' ? 'show active' : ''} `} id="profile" role="tabpanel" aria-labelledby="profile-tab"></div>
                                                    <div className={`tab-pane fade ${filterDurationTab == 'dates' ? 'show active' : ''} `} id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                                        <div className="ourClickBox">
                                                            <div className="dateBox filterpage notranslate">
                                                                <div className='notranslate' translate="no" ref={calendarRef}></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="ourClickBox">
                                                    <div className="chartBox">
                                                        {
                                                            minPriceValue != null &&
                                                            <div className="chartPrice">
                                                                <p>Price</p>
                                                            </div>
                                                        }
                                                        <div className="chartDraw mb-5" style={{ position: "relative" }}>
                                                            {

                                                                <>

                                                                    <div className='timeBox'>
                                                                        <div className="timeText">
                                                                            <div className="range-slider">
                                                                                <input
                                                                                    type="range"
                                                                                    min={0}
                                                                                    max={maxPriceValue}
                                                                                    value={(tempFromPrice)}
                                                                                    onChange={onSliderChange}
                                                                                    onMouseUp={handleEndPrice} // Trigger alert when the user finishes interaction
                                                                                    onTouchEnd={handleEndPrice}
                                                                                    onMouseDown={() => setActiveSlider('min')}
                                                                                    onTouchStart={() => setActiveSlider('min')}
                                                                                    id="slider-min"
                                                                                    className={activeSlider === 'min' ? 'on-top' : ''}
                                                                                />
                                                                                <input
                                                                                    type="range"
                                                                                    min={0}
                                                                                    max={maxPriceValue}
                                                                                    value={tempToPrice}
                                                                                    onChange={onSliderChange}
                                                                                    onMouseUp={handleEndPrice} // Trigger alert when the user finishes interaction
                                                                                    onTouchEnd={handleEndPrice}
                                                                                    onMouseDown={() => setActiveSlider('max')}
                                                                                    onTouchStart={() => setActiveSlider('max')}
                                                                                    id="slider-max"
                                                                                    className={activeSlider === 'max' ? 'on-top' : ''}
                                                                                />
                                                                            </div>
                                                                            <div className="countBox">
                                                                                <h6>€{tempFromPrice > 0 ? Math.round(LogSlider((tempFromPrice))) : tempFromPrice}</h6>
                                                                                <h6>
                                                                                    <span className='notranslate' translate="no">
                                                                                        €{Number(tempToPrice) > 0 ? Math.round(LogSlider((tempToPrice))) : tempToPrice}
                                                                                    </span>
                                                                                </h6>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </>
                                                            }


                                                        </div>
                                                    </div>
                                                    <div className="timeBox">
                                                        <div className="timeText">
                                                            <p>Start time</p>
                                                            <div className="range-slider">
                                                                <input
                                                                    type="range"
                                                                    min="0"
                                                                    max="1440"
                                                                    value={minValue}
                                                                    onChange={handleMinChange}
                                                                    onMouseUp={handleEnd} // Trigger alert when the user finishes interaction
                                                                    onTouchEnd={handleEnd}
                                                                    onMouseDown={() => setActiveTimeSlider('min')}
                                                                    onTouchStart={() => setActiveTimeSlider('min')}
                                                                    id="slider-min"
                                                                    className={activeTimeSlider === 'min' ? 'on-top' : ''}
                                                                />
                                                                <input
                                                                    type="range"
                                                                    min="0"
                                                                    max="1440"
                                                                    value={maxValue}
                                                                    onChange={handleMaxChange}
                                                                    onMouseUp={handleEnd} // Trigger alert when the user finishes interaction
                                                                    onTouchEnd={handleEnd}
                                                                    onMouseDown={() => setActiveTimeSlider('max')}
                                                                    onTouchStart={() => setActiveTimeSlider('max')}
                                                                    id="slider-max"
                                                                    className={activeTimeSlider === 'max' ? 'on-top' : ''}
                                                                />
                                                            </div>
                                                            <div className="countBox">
                                                                <h6>{convertToTime(minValue)}</h6>
                                                                <h6>{convertToTime(maxValue)}</h6>

                                                            </div>

                                                        </div>
                                                    </div>
                                                    {/* <div className="categories comSeacrh_input">
                                                        <div className="titleCat">
                                                            <p>Categories</p>
                                                            <div className={`searchBox ${categorySearch ? 'active' : ''}`}>
                                                                <a className="iconS" href="javascript:void(0)" onClick={() => {
                                                                    setCategorySearch(true)
                                                                    document.getElementById("categoryInput").focus();
                                                                }}><i className="bi bi-search"></i></a>
                                                                <input className="clickList" id='categoryInput' name='categoryInput' type="text" value={categoryInput} placeholder="Search" onChange={(e) => onCategoryChange(e)} />
                                                                <a className="iconX" href="javascript:void(0)" onClick={() => onResetCategory()}><i className="bi bi-x"></i></a>
                                                            </div>
                                                        </div>
                                                        <div className="catMenuBox">
                                                            {

                                                                categories.length > 0 ?
                                                                    <>
                                                                        <ul className='mb-2 filterSidebarList'>
                                                                            {
                                                                                visibleCategories.map((cat, i) => {
                                                                                    return (
                                                                                        <li key={i}>
                                                                                            <div className="clickTo">
                                                                                                <input type="checkbox"
                                                                                                    className="keyword-checkbox"
                                                                                                    onChange={() => handleCheckboxChange(String(cat.id))}
                                                                                                    checked={selectedCategories.includes(String(cat.id))}
                                                                                                />
                                                                                                <label for="" className="keyword-label" onClick={() => handleCheckboxChange(String(cat.id))} style={{ cursor: "pointer" }}>{cat.name}</label>
                                                                                            </div>
                                                                                            <p className="num">{cat.product_count}</p>
                                                                                        </li>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </ul>

                                                                    </> :
                                                                    !isLoading &&
                                                                    <p className='mb-1'>No Categories Found</p>
                                                            }
                                                        </div>
                                                        {remainingCatCount > 0 && !showAllCat && (
                                                            <div className="seeMore">
                                                                <a href="javascript:void(0)" onClick={handleSeeMoreClick}>
                                                                    See {remainingCatCount} more
                                                                </a>
                                                            </div>
                                                        )}
                                                        {showAllCat && (
                                                            <div className="seeMore">
                                                                <a href="javascript:void(0)" onClick={handleSeeLessClick}>
                                                                    See less
                                                                </a>
                                                            </div>
                                                        )}
                                                    </div> */}
                                                    <div className="feature comSeacrh_input">
                                                        <div className="titleCat">
                                                            <p>Features</p>
                                                            {/* <input type='text' value={featureSearch} onChange={(e) => onFeatureChange(e)} className='commonInputSecond mb-3' /> */}
                                                            <div className={`searchBox ${featureSearch ? 'active' : ''}`}>
                                                                <a className="iconS" href="javascript:void(0)" onClick={() => {
                                                                    setFeatureSearch(true)
                                                                    document.getElementById("featureInput").focus();
                                                                }}><i className="bi bi-search"></i></a>
                                                                <input className="clickList" type="text" id='featureInput' name='featureInput' value={featureInput} placeholder="Search" onChange={(e) => onFeatureChange(e)} />
                                                                <a className="iconX" href="javascript:void(0)" onClick={() => onResetFeature()}><i className="bi bi-x"></i></a>
                                                            </div>
                                                        </div>
                                                        <div className="catMenuBox">
                                                            {

                                                                features.length > 0 ?

                                                                    <>
                                                                        <ul className='mb-2 filterSidebarList'>
                                                                            {
                                                                                visibleFeatures.map((fe, i) => {
                                                                                    return (
                                                                                        <li key={i}>
                                                                                            <div className="clickTo">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="keyword-checkbox"
                                                                                                    checked={checkFeatureSelected(fe)}
                                                                                                    onChange={(e) => handleFeatureCheckboxChange(e, fe)}
                                                                                                />
                                                                                                <label for="" className="keyword-label" onClick={(e) => handleFeatureCheckboxChange(e, fe)} style={{ cursor: "pointer" }}>{fe.type == 'language' ? fe.label : fe.label}</label>
                                                                                            </div>
                                                                                            <p className="num">{fe.product_count}</p>
                                                                                        </li>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </ul>

                                                                    </> :
                                                                    !isLoading &&
                                                                    <p className='mb-1'>No Features Found</p>
                                                            }
                                                        </div>
                                                        {remainingFeCount > 0 && !showAllFe && (
                                                            <div className="seeMore">
                                                                <a href="javascript:void(0)" onClick={handleSeeFeMoreClick}>
                                                                    See {remainingFeCount} more
                                                                </a>
                                                            </div>
                                                        )}
                                                        {showAllFe && (
                                                            <div className="seeMore">
                                                                <a href="javascript:void(0)" onClick={handleSeeFeLessClick}>
                                                                    See less
                                                                </a>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="filterReset">
                                                        <a href="javascript:void(0)" onClick={() => resetFilter()}><i className="fa-solid fa-circle-xmark"></i> Reset filter</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-9">
                                    {
                                        isLoading ?
                                            <SKProductList records={10} /> :

                                            <>
                                                {
                                                    productList.length > 0 ?
                                                        productList.map((product, i) => {
                                                            let amt = '';
                                                            if (product.product_rate_pricing_categories && product.product_rate_pricing_categories.length > 0) {
                                                                amt = product.product_rate_pricing_categories[0].lowest_amount;
                                                            } else if (product.product_rate_tiered_pricing_categories && product.product_rate_tiered_pricing_categories.length > 0) {
                                                                amt = product.product_rate_tiered_pricing_categories[0].lowest_amount;
                                                            }
                                                            return (
                                                                <Link
                                                                    // to={'/tour/' + product.slug} 
                                                                    to={(slugLang ? ('/' + slugLang) : '') + '/tour/' + product?.[slugField]}

                                                                    style={{ width: "100%" }}>
                                                                    <div className="ourTourBox" key={i}>
                                                                        <div className="leftImg">
                                                                            <img
                                                                                src={helper.S3Url + '/' + helper.productImageDir + '/' + product.cover_image}

                                                                                alt={product?.cover_image_alternate_text}
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = noTour
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="rightText">
                                                                            <div className="card_top_content">
                                                                                <div className="fillBox">
                                                                                    <p><i className="fa-solid fa-location-dot"></i>
                                                                                        {/* {product.address ? product.address : '-'} */}
                                                                                        {product?.product_detail?.meeting_point_location ?
                                                                                            formatMeetingLocation(product?.product_detail?.meeting_point_location) :
                                                                                            product?.product_detail?.location ?
                                                                                                formatMeetingLocation(product?.product_detail?.location)
                                                                                                : (product?.address ? product?.address : "-")}
                                                                                    </p>
                                                                                    <div className="wishClik">
                                                                                        <a href="javascript:void(0)"
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation(); // Prevent the Link from triggering
                                                                                                toggleLike(product.liked, i, product.id);
                                                                                            }}
                                                                                        >

                                                                                            <img src={product.liked ? heartFill : heart} alt="heart-fill" />
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                                <h5
                                                                                    // data-bs-toggle="tooltip" data-bs-placement="top"
                                                                                    // data-bs-custom-className="custom-tooltip"
                                                                                    // data-bs-title="This top tooltip is themed via CSS variables."
                                                                                    title={product.title}>{product.title}</h5>
                                                                                {
                                                                                    product?.short_description &&
                                                                                    <p className="min_height twoLine">{product?.short_description}</p>
                                                                                }
                                                                                <ul>
                                                                                    {
                                                                                        product.product_rates.filter((e) => e.availability_seat_type == 'non_private').length > 0 &&
                                                                                        <li><p><i className="fa-solid fa-user-group"></i> Groups</p></li>
                                                                                    }
                                                                                    {
                                                                                        product.product_rates.filter((e) => e.availability_seat_type == 'private').length > 0 &&
                                                                                        <li><p><i className="fa-solid fa-user"></i> Private</p></li>
                                                                                    }
                                                                                    {
                                                                                        product?.duration &&
                                                                                        <li><p><i className="fa-solid fa-clock"></i> {product.duration}</p></li>
                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                            <div className="priceBox">
                                                                                <h6>{amt ? 'From € ' + amt : ''}</h6>
                                                                                {
                                                                                    product?.product_detail?.trustindex_rating != null &&

                                                                                    <div
                                                                                        className='filterpagereview'
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html: product?.product_detail?.trustindex_rating
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                            )
                                                        }) : <TableRecordNotFound />
                                                }
                                            </>
                                    }


                                    {
                                        productList.length > 0 &&
                                        <RecordPagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            onPageChange={onPageChange}
                                            totalItems={totalItems}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Index